import { AutogenLayoutDriverDeductionHistoryReport } from "./autogen/AutogenLayoutDriverDeductionHistoryReport";

export class DriverDeductionHistoryReport extends AutogenLayoutDriverDeductionHistoryReport {
    override onLoad() {
        this.textboxGroupBy.selectedItem = this.textboxGroupBy.items[0];
    }

    textboxGroupByOnChange() {
        const reportType = this.textboxGroupBy.text
        if (reportType == "Payee") {
            this.checkboxSubtotalByTractor.enabled = true;
        } else {
            this.checkboxSubtotalByTractor.enabled = false;
            this.checkboxSubtotalByTractor.checked = false;
        }
    }
}
